module.exports = __webpack_public_path__ + "static/media/Screenshot_2.d68cae2a.png";